import { COMPANY_IDS } from "./companies";

import { z } from "zod";

export const APP_TITLE = {
  short: "TOPAS 2",
  long: "Togpersonalets Assistent",
};

export const CONDUCTOR_POSITIONS = [
  "4014",
  "4015",
  "4017",
  "4019",
  "4028",
  "4029",
];

export const DRIVER_POSITIONS = [
  "4010",
  "4011",
  "4012",
  "4016",
  "4018",
  "4027",
];

export const CONDUCTOR = "Konduktør";
export const CONDUCTORS = "Konduktører";

export const DRIVER = "Lokomotivfører";
export const DRIVERS = "Lokomotivførere";

export const DEVELOPER = "Developer";

const groupIdByCompanyId = z.record(z.enum(COMPANY_IDS), z.string().uuid());

export const aadGroupsSchema = z.object({
  developer: z.string().uuid(),
  tev_testgruppe: z.string().uuid(),
  driving_style: z.string().uuid(),
  conductor: groupIdByCompanyId,
  driver: groupIdByCompanyId,
});

export type AadGroups = z.infer<typeof aadGroupsSchema>;

export const DEFAULT_TIMEZONE = "Europe/Oslo";
